module.exports = __webpack_public_path__ + "media/packs/images/flags/KN-e213bfa75cf3046d337a14b0f435a1a5.svg";